import React from 'react';
import PropTypes from 'prop-types';
import FieldPreview from '../FieldPreview';
/**
 * Slouží pro zobrazení readonly textove hodnoty.
 */

function TextFieldPreview(props) {
  return /*#__PURE__*/React.createElement(FieldPreview, props);
}

TextFieldPreview.propTypes = {
  className: PropTypes.string,

  /**
   * Barva zobrazovane hodnoty.
   */
  color: PropTypes.oneOf(['initial', 'error', 'inherit', 'primary', 'secondary', 'textPrimary', 'textSecondary']),

  /**
   * `true` pokud se ma komponenta zobrazit v cele dostupne sirce.
   */
  fullWidth: PropTypes.bool,

  /**
   * Pomocny text, zobrazovany pod vstupem.
   */
  helperText: PropTypes.string,

  /**
   * Custom vlastnosti `Input`.
   */
  InputProps: PropTypes.shape({}),

  /**
   * Label fieldu.
   */
  label: PropTypes.string,
  margin: PropTypes.oneOf(['none', 'dense', 'normal']),
  size: PropTypes.oneOf(['xsmall', 'small', 'normal', 'large']),
  style: PropTypes.shape({}),
  value: PropTypes.string
};
TextFieldPreview.defaultProps = {
  className: undefined,
  color: undefined,
  fullWidth: false,
  helperText: undefined,
  InputProps: undefined,
  label: undefined,
  margin: undefined,
  size: undefined,
  style: undefined,
  value: ''
};
export default TextFieldPreview;